import { Controller } from "@hotwired/stimulus";

import { ApiError, post } from "../lib/http.js";
import { showToast } from "../lib/toast.js";

/** Лайк на рецензии и комментарии. */
export default class extends Controller {
  static targets = ["count", "trigger"];
  static values = {
    appLabel: String,
    model: String,
    objectId: Number,
    liked: Boolean,
    count: Number,
    authenticated: Boolean,
    loginTooltip: { type: String, default: "Войдите для оценки" },
    likeTooltip: { type: String, default: "Нравится" },
    unlikeTooltip: { type: String, default: "Не нравится" },
  };

  connect() {
    this.render();
  }

  /**
   * Ставит или снимает лайк.
   *
   * Гостю показываем подсказку, а не редирект: клик по лайку — не то место,
   * где человек ждёт ухода со страницы.
   */
  async toggle(event) {
    event.preventDefault();

    if (this.busy) return;
    if (!this.authenticatedValue) {
      showToast(this.loginTooltipValue, "info");
      return;
    }

    this.setBusy(true);

    try {
      const data = await post("/api/likes/toggle/", {
        app_label: this.appLabelValue,
        model: this.modelValue,
        object_id: this.objectIdValue,
      });

      this.likedValue = Boolean(data.liked);
      this.countValue = Number(data.likes_count) || 0;
      this.render();
    } catch (error) {
      // Сессия истекла, пока страница была открыта, — уводим на вход.
      if (error instanceof ApiError && [401, 403].includes(error.status)) {
        this.redirectToLogin();
        return;
      }
      showToast(error.message);
    } finally {
      this.setBusy(false);
    }
  }

  /**
   * Приводит кнопку, счётчик и подсказку в соответствие состоянию.
   *
   * Состояние показывает класс, а не подмена src у картинки: лапа теперь
   * иконка из спрайта и красится currentColor.
   */
  render() {
    this.countTarget.textContent = this.countValue;

    if (!this.hasTriggerTarget) return;

    this.triggerTarget.classList.toggle("like-pill--on", this.likedValue);

    const tooltip = this.authenticatedValue
      ? this.likedValue
        ? this.unlikeTooltipValue
        : this.likeTooltipValue
      : this.loginTooltipValue;

    this.triggerTarget.setAttribute("aria-pressed", String(this.likedValue));
    this.triggerTarget.setAttribute("aria-label", tooltip);
    this.triggerTarget.setAttribute("title", tooltip);
  }

  setBusy(busy) {
    this.busy = busy;
    if (!this.hasTriggerTarget) return;

    this.triggerTarget.disabled = busy;
    this.triggerTarget.setAttribute("aria-busy", String(busy));
  }

  redirectToLogin() {
    const { pathname, search, hash } = window.location;
    const next = encodeURIComponent(`${pathname}${search}${hash}`);
    window.location.href = `/accounts/login/?next=${next}`;
  }
}
